module.exports = __webpack_public_path__ + "static/img/1_2_3_3.415b79ad.jpg";